import React, { useEffect, useContext } from 'react';
import * as sc from './impersonation-banner.styles';
import UserInitializationContext from '|/context/user-initialization-context';
import useAnalyticsContext from '|/hooks/use-analytics-context';

const ImpersonationBanner = () => {
  const { accessToken, isImpersonating } = useContext(UserInitializationContext);
  const { user = null } = accessToken || {};
  const { trackEvent } = useAnalyticsContext();

  useEffect(() => {
    if (isImpersonating) {
      trackEvent('header - banner - viewed banner', {
        bannerType: 'impersonation-banner'
      });
    }
  }, [trackEvent, isImpersonating]);

  if (user === null || !isImpersonating) return null;

  return (
    <sc.Wrapper>
      <sc.ImpersonationBanner data-testid="impersonation-banner">
        <p>
          Currently Impersonating User:{' '}
          <strong>
            {user?.given_name} {user?.family_name}
          </strong>
        </p>
        <a
          href={`/manageuser/deimpersonate?i=userdetails&returnUrl=${process.env.CARMA_URL}/funnel?customerId=${user?.user_id}`}
          target="_self"
          aria-label="stop impersonating"
          onClick={() => {
            trackEvent('header - banner - dismissed banner', {
              bannerType: 'impersonation-banner'
            });
          }}
          data-analytics-id="pp_impersonation_stop"
        >
          Stop
        </a>
      </sc.ImpersonationBanner>
    </sc.Wrapper>
  );
};

export default ImpersonationBanner;
